module.exports = __webpack_public_path__ + "img/DualRing-1.1s-200px.5a2fc977.svg";